import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";
import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

async function getCarousel() {
  const data = await axiosInstance({
    url: "/carousel",
    method: "GET",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function createCarousel(formData) {
  const data = await axiosInstance({
    url: "/carousel",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function updateCarousel(formData) {
  const data = await axiosInstance({
    url: `/carousel/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function deleteCarousel(formData) {
  const data = await axiosInstance({
    url: `/carousel/${formData}`,
    method: "DELETE",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useCarousel() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.carousel],
    queryFn: getCarousel,
  });
  return data;
}

export function useUpdateCarousel() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => updateCarousel(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.carousel]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useAddCarousel() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => createCarousel(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.carousel]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
export function useDeleteCarousel() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => deleteCarousel(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.carousel]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
